var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuStatus),expression:"menuStatus"},{name:"click-outside",rawName:"v-click-outside",value:(_vm._closeMenu),expression:"_closeMenu"}],staticClass:"wx-menu",style:(_vm.menuPosition),attrs:{"position":_vm.menuPosition}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6a72f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Menu.vue
// module id = null
// module chunks = 